import { Headcount } from "@prisma/client";
import React from "react";
import { SelectInput } from "~/components/ui/core/BetterSelectInput";
import { TextInput } from "~/components/ui/core/TextInput";
import { useI18n } from "~/lib/i18n/useI18n";
import { getHeadcountLabel } from "~/services/headcount";

type Event = {
  target: {
    name?: string;
    value: Headcount;
  };
};

type Props = {
  dense?: boolean;
  disabled?: boolean;
  name?: string;
  onChange: (event: Event) => void;
  value: Headcount | undefined;
};

export const CompanyHeadcountSelector: React.FC<Props> = ({
  dense = false,
  disabled = false,
  name,
  onChange,
  value,
}) => {
  const { t } = useI18n();
  const groups = [{ label: "", options: Object.values(Headcount) }];

  return (
    <SelectInput
      dense={dense}
      disabled={disabled}
      formatLabel={() => (
        <TextInput
          dense={dense}
          readOnly
          className="cursor-pointer"
          placeholder={t("components.ui.company-headcount-selector.select-headcount")}
          value={value ? getHeadcountLabel(value) : ""}
        />
      )}
      formatOption={(option) => (option ? getHeadcountLabel(option) : "-")}
      groups={groups}
      hideGroupLabels={true}
      onChange={(event) => {
        const [headcount] = event.target.value;
        if (!headcount) return;

        onChange({ target: { name, value: headcount } });
      }}
      optionToId={(option) => option ?? ""}
      placeholder="Select a headcount"
      value={[value]}
    />
  );
};
